import { meta } from '../../../../constants';
import type { DemoSourceType } from '../types';
import type { TiktokSourceValue } from './types';

const extraTiktokSources: DemoSourceType<TiktokSourceValue> = {
  'tiktok-aprilvk_art': {
    label: 'TikTok: @aprilvk_art',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kkpavb1j',
      name: 'TikTok',
      source: 'https://www.tiktok.com/@aprilvk_art'
    }
  },
  'tiktok-fusetv': {
    label: 'TikTok: @fusetv',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kkpavhtk',
      name: 'TikTok',
      source: 'https://www.tiktok.com/@fusetv'
    }
  },
  'tiktok-warnermusicmex': {
    label: 'TikTok: @warnermusicmex',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kkpavnrc',
      name: 'TikTok',
      source: 'https://www.tiktok.com/@warnermusicmex'
    }
  },
  'tiktok-yourtravelsdestination': {
    label: 'TikTok: @yourtravelsdestination',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kkpavu4p',
      name: 'TikTok',
      source: 'https://www.tiktok.com/@yourtravelsdestination'
    }
  }
};

export const previewTiktokSources: DemoSourceType<TiktokSourceValue> = {
  'tiktok-savv.labrant': {
    label: 'TikTok: @savv.labrant',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kgte7e65',
      name: 'TikTok',
      source: 'https://www.tiktok.com/@savv.labrant'
    }
  },
  'tiktok-travel_gals': {
    label: 'TikTok: @travel_gals',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokProfile',
      id: 'kkpav4or',
      name: 'TikTok',
      source: '@travel_gals'
    }
  },
  'tiktok-gaming': {
    label: 'TikTok: #gaming',
    source: {
      platform: 'tiktok',
      connectionType: 'tiktokHashtag',
      id: 'kkpavb1j',
      name: 'TikTok',
      source: '#gaming'
    }
  },
  ...(meta.alias === 'tiktok-feed' ? extraTiktokSources : {})
};
